<template>
  <div class="card" v-show="currentCardId == 'edu-history'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>学歴を入力</h2>
        <p>
          学校名・学位・期間を入力してください。ページの関係上、高校から入力するのがおすすめです
        </p>
      </div>
      <div class="card-content card-content-list">
        <div class="edit-form-list">
          <transition-group name="fade" tag="div">
            <HistoryItem
              v-for="(item, index) in formatData.educationalHistories"
              :key="item.uuid"
              @add-history-item="addEducationalHistory"
              @delete-history-item="deleteEducationalHistory"
              @move-history-item="moveEducationalHistory"
              @click.native="activateHistoryItem(item.uuid)"
              :item="item"
              :length="formatData.educationalHistories.length"
              :index="index"
              :id="item.uuid"
              :class="{ active: activeHistoryItem == item.uuid }"
              :minYear="basicData.birthYear"
              :createDate="formatData.createDate"
              :descriptionPlaceholder="'School name, Degree'"
              :descriptionMaxLength="descriptionMaxLength"
            />
          </transition-group>
          <div class="add-list-item">
            <el-button
              icon="el-icon-plus"
              circle
              type="success"
              :disabled="
                formatData.educationalHistories.length >=
                MAX_EDUCATIONAL_HISTORIES
              "
              @click="addEducationalHistory()"
            />
            <p
              v-if="
                formatData.educationalHistories.length >=
                MAX_EDUCATIONAL_HISTORIES
              "
              class="limit-message"
            >
              学歴は{{ MAX_EDUCATIONAL_HISTORIES }}件まで登録できます
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import {
  MAX_EDUCATIONAL_HISTORIES,
  descriptionMaxLength,
  useEnglishResumeFormatData,
  useEnglishResumeHistoriesApi
} from '@/composables/format-edit/useEnglishResumeFormatData'

defineProps<{
  currentCardId?: string
  basicData: Record<string, unknown>
}>()

const formatData = useEnglishResumeFormatData()
const {
  activeHistoryItem,
  addEducationalHistory,
  deleteEducationalHistory,
  moveEducationalHistory,
  activateHistoryItem
} = useEnglishResumeHistoriesApi()
</script>

<style scoped lang="scss">
.limit-message {
  margin: 8px 0 0;
  font-size: 0.78rem;
  color: #999;
  text-align: center;
}
</style>
